import { ReactElement, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { IDictionary, NullValue } from "../../../types";
import { MenuItem, Select } from "@mui/material";
import { sortText } from "../../../system/utils";

interface IFilterDialogProps {
  handleClose: () => void;
  onHandleAccept: (filter: IDictionary<string[]>) => void;
  keywordMap: IDictionary<Set<string>>;
  open: boolean;
  currentFilter: IDictionary<string[]>;
}


const FilterDialog = ({ open, handleClose, onHandleAccept, keywordMap, currentFilter }: IFilterDialogProps): ReactElement => {
  const [filter, setFilter] = useState<IDictionary<string[]>>( { ...currentFilter });

  const keys = Object.keys(keywordMap).sort(sortText);

  const handleChange = (key: string, options: string[]) => {
    let value: string[] = [];

    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i] !== NullValue){
        value.push(options[i]);
      } else if (i > 0) {
        value = [ NullValue ];
        break;
      }
    }

    setFilter({
      ...filter,
      [key]: value
    });
  };

  const onHandleReset = () => {
    const newFilter: IDictionary<string[]> = {};

    keys.forEach(key => newFilter[key] = [ NullValue ]);
    setFilter(newFilter);
  };


  return(
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Filter</DialogTitle>
      <DialogContent dividers={true}>
        { keys.map((key, index) => {

          const options: string[] = [];

          keywordMap[key].forEach((value) => {
            options.push(value);
          });

          const parentKey = `filter-${key}-${index}`;

          return (
            <div key={parentKey} className="display-flex-row align-items-center mb-1" style={{ width: 400 }}>
              <strong className="flex-grow-0" style={{ width: 150 }}>{key}</strong>
              <Select
                variant="standard"
                className="flex-grow-1"
                value={filter[key]}
                multiple={true}
                onChange={(e) => handleChange(key, e.target.value as string[])}>
                <MenuItem value={NullValue}>NONE</MenuItem>
                { options.sort(sortText).map((opt, i) => {
                  return <MenuItem value={opt} key={`${parentKey}-opt-${i}`}>{opt}</MenuItem>;
                })
                }
              </Select>
            </div>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onHandleAccept(filter)} color="primary" variant="contained" >
          Accept
        </Button>
        <Button onClick={onHandleReset} className="neutral-value" variant="contained" >
          Reset
        </Button>
        <Button onClick={handleClose} color="secondary" variant="contained" >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
